module.exports = __webpack_public_path__ + "static/icon-3e9dc0651277405e521c4c4b8864ffd9.svg";